import { onViewChange, allToShortest, allToTallest, queryAll } from '@/resources/assets/js/modules/utils';

class RelatedLinks {
  constructor(root) {
    this.root = root;
    this.cardsImages = [...this.root.querySelectorAll('.CardBlog img')]
    this.cardsTitles = [...this.root.querySelectorAll('.CardBlog-body h3')]

    if (window.innerWidth > 767) {
      this.#init();
    }
  }

  #init() {
    if (this.cardsImages.length) {
      setTimeout(() => {
        allToShortest(this.cardsImages);
        allToTallest(this.cardsTitles);
      }, 100);
      onViewChange(allToShortest.bind(this, this.cardsImages));
      onViewChange(allToTallest.bind(this, this.cardsTitles));
    }
  }
}

[...document.querySelectorAll('.RelatedLinks-rail')].forEach(node => {
  new RelatedLinks(node);
});